import React from 'react';
import styled from '@emotion/styled';
const Contact = () => {
 return (
  <Container>
   <ContactArea>
    <ContactAreaWrapper>
     <TextHeader className="text-content">
      <H1>
       Partner with us to simplify eCommerce shipping from China to Nigeria.
      </H1>
      <Descriptions>
       Call our China office at <Span>[+86 139 7284 5610]</Span> or reach us in
       Nigeria at <Span>[+234 803 724 1956]</Span> to get started.
      </Descriptions>
     </TextHeader>
    </ContactAreaWrapper>
   </ContactArea>
  </Container>
 );
};

export default Contact;

const Container = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 margin: 0 -5.4375rem -1rem;
 padding: 1rem 5.4375rem;
 position: relative;
 overflow: hidden;
 background-image: url('/static/img/cml/partner_hero_bg.png');
 background-size: cover;
 background-position: center center;

 width: 100vw;
 max-height: 700px;
 min-height: 600px;

 @media (max-width: 884px) {
  padding: 0;
  margin: 0 -24px;
  min-height: 500px;
 }
`;

const ContactArea = styled.div`
 width: 100%;
 display: flex;
 justify-content: center;
 align-items: center;

 @media (max-width: 884px) {
  justify-content: center;
  text-align: center;
 }

 @media (max-width: 480px) {
  padding: 0;
  margin: auto;
 }
`;

const ContactAreaWrapper = styled.div`
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 gap: 28px;
 max-width: 870px;

 @media (max-width: 884px) {
  display: flex;
  max-width: 700px;
 }

 @media (max-width: 480px) {
  width: 90vw;
 }

 & > .text-content {
  animation-name: slide-in;
  animation-duration: 0.4s;
  animation-timing-function: ease-in-out;

  @keyframes slide-in {
   from {
    transform: translateX(-100%);
   }
   to {
    transform: none;
   }
  }
 }
`;

const TextHeader = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 24px;
`;

const H1 = styled.h1`
 font-size: 40px;
 font-weight: bold;
 line-height: 48px;
 text-align: center;

 @media (max-width: 884px) {
  font-size: 32px;
  line-height: 37px;
 }

 @media (max-width: 480px) {
  font-size: 28px;
  line-height: 36px;
 }
`;

const Span = styled.span`
 color: ${({ theme }) => theme.palette.redFontColor};
`;

const Descriptions = styled.div`
 font-size: 20px;
 font-weight: 400;
 line-height: 28px;
 text-align: center;
 max-width: 600px;

 @media (max-width: 480px) {
  font-size: 16px;
  line-height: 18px;
 }
`;
